import { Assessment } from './assessment';

export interface GroupedAssessments {
  name: string;
  class: string;
  list: Assessment[];
  isOpen: boolean;
}
